module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "评测报告"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "insertUserForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.reportParam,
      "rules": _vm.ruleUser
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师：",
      "label-width": 90
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.reportParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.reportParam, "tchId", $$v)
      },
      expression: "reportParam.tchId"
    }
  }, _vm._l((_vm.tchAll), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.tchName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教运营：",
      "label-width": 90
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.reportParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.reportParam, "studyAdviserId", $$v)
      },
      expression: "reportParam.studyAdviserId"
    }
  }, _vm._l((_vm.studyAll), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导：",
      "label-width": 90
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.reportParam.tutorId),
      callback: function($$v) {
        _vm.$set(_vm.reportParam, "tutorId", $$v)
      },
      expression: "reportParam.tutorId"
    }
  }, _vm._l((_vm.tutorAll), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 90,
      "label": "测评报告："
    }
  }, [_c('file-upload', {
    attrs: {
      "defaultFileList": _vm.defaultAudioList,
      "text": "点击上传测评报告(PDF格式)",
      "accept": "application/*"
    },
    on: {
      "on-file-change": _vm.handleReportDoc
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "对应课节：",
      "label-width": 90,
      "prop": "lessonNum"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.reportParam.lessonNum),
      callback: function($$v) {
        _vm.$set(_vm.reportParam, "lessonNum", _vm._n($$v))
      },
      expression: "reportParam.lessonNum"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.insert
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21df918f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/crm/StageReportModal.vue
// module id = 1675
// module chunks = 8